import { render, staticRenderFns } from "./EnquestesItem.vue?vue&type=template&id=36d9d6a8&scoped=true&"
import script from "./EnquestesItem.vue?vue&type=script&lang=js&"
export * from "./EnquestesItem.vue?vue&type=script&lang=js&"
import style0 from "./EnquestesItem.vue?vue&type=style&index=0&id=36d9d6a8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d9d6a8",
  null
  
)

export default component.exports